/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript';
// @ts-ignore
import request from "../request";
const mockUrl_0_0_0_0 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_0 = "";
const prodUrl_0_0_0_0 = "";
const dataKey_0_0_0_0 = "data";
/**
 * 接口 商家保证金列表 的 **请求配置**
 *
 * @分类 4.58.0
 * @请求头 `POST /erp/SupplyDeposit/getSupplyDepositList`
 */
const postGetSupplyDepositListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/SupplyDeposit/getSupplyDepositList",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetSupplyDepositList",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 商家保证金列表 的 **请求函数**
 *
 * @分类 4.58.0
 * @请求头 `POST /erp/SupplyDeposit/getSupplyDepositList`
 */
export const postGetSupplyDepositList = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postGetSupplyDepositListRequestConfig, requestData),
    ...args
  );
};
postGetSupplyDepositList.requestConfig = postGetSupplyDepositListRequestConfig;
/**
 * 接口 商家保证金列表 - 导出 的 **请求配置**
 *
 * @分类 4.58.0
 * @请求头 `POST /erp/SupplyDeposit/exportSupplyDepositList`
 */
const postExportSupplyDepositListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/SupplyDeposit/exportSupplyDepositList",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postExportSupplyDepositList",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 商家保证金列表 - 导出 的 **请求函数**
 *
 * @分类 4.58.0
 * @请求头 `POST /erp/SupplyDeposit/exportSupplyDepositList`
 */
export const postExportSupplyDepositList = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postExportSupplyDepositListRequestConfig, requestData),
    ...args
  );
};
postExportSupplyDepositList.requestConfig =
  postExportSupplyDepositListRequestConfig;
/**
 * 接口 商家保证金流水记录 的 **请求配置**
 *
 * @分类 4.58.0
 * @请求头 `POST /erp/SupplyDeposit/getSupplyDepositTransactions`
 */
const postGetSupplyDepositTransactionsRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/SupplyDeposit/getSupplyDepositTransactions",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetSupplyDepositTransactions",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 商家保证金流水记录 的 **请求函数**
 *
 * @分类 4.58.0
 * @请求头 `POST /erp/SupplyDeposit/getSupplyDepositTransactions`
 */
export const postGetSupplyDepositTransactions = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postGetSupplyDepositTransactionsRequestConfig, requestData),
    ...args
  );
};
postGetSupplyDepositTransactions.requestConfig =
  postGetSupplyDepositTransactionsRequestConfig;
/**
 * 接口 商家保证金流水记录 - 导出 的 **请求配置**
 *
 * @分类 4.58.0
 * @请求头 `POST /erp/SupplyDeposit/exportSupplyDepositTransactions`
 */
const postExportSupplyDepositTransactionsRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/SupplyDeposit/exportSupplyDepositTransactions",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postExportSupplyDepositTransactions",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 商家保证金流水记录 - 导出 的 **请求函数**
 *
 * @分类 4.58.0
 * @请求头 `POST /erp/SupplyDeposit/exportSupplyDepositTransactions`
 */
export const postExportSupplyDepositTransactions = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postExportSupplyDepositTransactionsRequestConfig, requestData),
    ...args
  );
};
postExportSupplyDepositTransactions.requestConfig =
  postExportSupplyDepositTransactionsRequestConfig;
/**
 * 接口 设置保证金阈值配置 的 **请求配置**
 *
 * @分类 4.58.0
 * @请求头 `POST /erp/SupplyDeposit/setSupplyDepositThreshold`
 */
const postSetSupplyDepositThresholdRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/SupplyDeposit/setSupplyDepositThreshold",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postSetSupplyDepositThreshold",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 设置保证金阈值配置 的 **请求函数**
 *
 * @分类 4.58.0
 * @请求头 `POST /erp/SupplyDeposit/setSupplyDepositThreshold`
 */
export const postSetSupplyDepositThreshold = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postSetSupplyDepositThresholdRequestConfig, requestData),
    ...args
  );
};
postSetSupplyDepositThreshold.requestConfig =
  postSetSupplyDepositThresholdRequestConfig;
/**
 * 接口 获取保证金阈值配置 的 **请求配置**
 *
 * @分类 4.58.0
 * @请求头 `POST /erp/SupplyDeposit/getSupplyDepositThreshold`
 */
const postGetSupplyDepositThresholdRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/SupplyDeposit/getSupplyDepositThreshold",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.raw,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetSupplyDepositThreshold",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取保证金阈值配置 的 **请求函数**
 *
 * @分类 4.58.0
 * @请求头 `POST /erp/SupplyDeposit/getSupplyDepositThreshold`
 */
export const postGetSupplyDepositThreshold = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postGetSupplyDepositThresholdRequestConfig, requestData),
    ...args
  );
};
postGetSupplyDepositThreshold.requestConfig =
  postGetSupplyDepositThresholdRequestConfig;
/**
 * 接口 获取保证金阈值配置日志 的 **请求配置**
 *
 * @分类 4.58.0
 * @请求头 `POST /erp/SupplyDeposit/getSupplyDepositThresholdLog`
 */
const postGetSupplyDepositThresholdLogRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/SupplyDeposit/getSupplyDepositThresholdLog",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.raw,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetSupplyDepositThresholdLog",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取保证金阈值配置日志 的 **请求函数**
 *
 * @分类 4.58.0
 * @请求头 `POST /erp/SupplyDeposit/getSupplyDepositThresholdLog`
 */
export const postGetSupplyDepositThresholdLog = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postGetSupplyDepositThresholdLogRequestConfig, requestData),
    ...args
  );
};
postGetSupplyDepositThresholdLog.requestConfig =
  postGetSupplyDepositThresholdLogRequestConfig;
/* prettier-ignore-end */



// WEBPACK FOOTER //
// ./src/openapi/erp/supplyDeposit.js